import styled from 'styled-components';

export const Container = styled.div`
    position: relative;
    width: 100%;
    min-height: 84px;
    border-bottom: 1px solid var(--border);
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 12px;
    padding: 12px 20px;
    box-sizing: border-box;
    background: linear-gradient(135deg, var(--lavender) 0%, var(--primary) 50%, var(--peach) 100%);

    @media (max-width: 480px) {
        flex-wrap: wrap;
        justify-content: center;
        padding: 12px;
    }
`;

export const BrandLink = styled.a`
    display: flex;
    align-items: center;
    gap: 12px;
    text-decoration: none;
    color: inherit;
    flex-shrink: 0;
`;

export const LogoIcon = styled.img`
    height: 56px;
    width: 56px;
    border-radius: 16px;
    box-shadow: var(--shadow);
    flex-shrink: 0;
`;

export const Wordmark = styled.span`
    font-size: 1.6em;
    font-weight: 800;
    color: var(--text-title);
    white-space: nowrap;
`;

export const StoreBadgeContainer = styled.a`
    height: 44px;
    display: flex;
    justify-content: center;
    align-items: center;
    flex-shrink: 0;
`;

export const StoreBadge = styled.img`
    height: 100%;
`;
